import { useAuth } from '../contexts/auth-context';
import { authFetch, useFollows } from '../hooks/useApi';
import { matchesSessionSearch } from '../utils/dateNavigation';
import DayPicker from './DayPicker';

export default function BaanDayPicker({ selectedDay, onChange, scope, query }) {
  const { loggedIn, user } = useAuth();
  const { data: follows, error: followsError, loading } = useFollows(loggedIn && scope === 'following');
  const ids = follows?.following?.map(item => item.transponder) ?? [];
  async function hasData(day, signal) {
    if (scope === 'following' && !loggedIn) throw new Error('Log in om gevolgde sessies te bekijken.');
    if (scope === 'following' && (loading || followsError)) throw new Error(followsError || 'Gevolgde schaatsers worden nog geladen.');
    if (scope === 'following' && ids.length === 0) throw new Error('Volg eerst een schaatser om gevolgde sessies te bekijken.');
    const response = await authFetch(`/api/sessions?date=${day}`, { signal });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.sessions.some(session => matchesSessionSearch(session, query) &&
      (scope !== 'following' || ids.includes(session.transponder)));
  }
  return <DayPicker selectedDay={selectedDay} onChange={onChange} hasData={hasData}
    scopeKey={JSON.stringify([scope, query, loggedIn, user?.email, ids, loading, followsError])} />;
}
